import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rmt-checkbox',
  templateUrl: 'rmt-checkbox.html'
})
export class RmtCheckboxComponent {
  @ViewChild('input') input;
  @ViewChild('checkbox') checkbox;
  @Input() checkId:string=''
  @Input() newStyle: boolean = false;
  @Input() allowTextClickToggle: boolean = false;
  @Input() disable: boolean = false;
  @Output() ionChange = new EventEmitter();

  constructor() {    
  }

  ngAfterViewInit() {
    if (this.input.value)
      this.checkbox.value = this.input.value;
  }

  changeCheckbox(ev) {
    this.input.value = ev.value;
    this.ionChange.emit(ev);
  }

  changeInput(ev) {
    if (this.checkbox.value !== ev.value)
      this.checkbox.value = ev.value;
  }

  setValue(value) {
    this.checkbox.value = value;
  }

  getValue() {
    return this.checkbox.value;
  }

  toggleCheckbox() {
    if (this.checkbox && this.allowTextClickToggle)
      this.checkbox.setValue(!this.checkbox.value)
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-checkbox/rmt-checkbox.ts